<script lang="ts">
    import type { Page } from '@shared/types/Tilelist';
    import { injectWiring } from '@tilelist/application/wiring/TileListWiringContext.svelte.ts';
    import SegmentInterval from '@tilelist/components/bottom-paging-bar/SegmentInterval.svelte';
    import SegmentNavButton from '@tilelist/components/bottom-paging-bar/SegmentNavButton.svelte';
    import SegmentPage from '@tilelist/components/bottom-paging-bar/SegmentPage.svelte';
    import { pagedUrl } from '@tilelist/components/history/Utils.browser.ts';
    import { canonicalPage } from './CanonicalPage';
    import { getPaginationWithSegments } from './Segments';

    interface Props {
        rankedCount: number;
        sponsoredCount: number;
        pageItemCount?: number;
        pageContext: Page;
        rule: string;
    }

    let { rankedCount, sponsoredCount, pageItemCount, pageContext, rule }: Props = $props();

    const wiring = injectWiring(['selectionEvents']);

    const { segments, currentOffset } = $derived(
        getPaginationWithSegments({ rankedCount, sponsoredCount, pageItemCount }, pageContext),
    );

    function paginate(offset: number) {
        const page: Page = canonicalPage({
            l: pageContext.l,
            o: offset.toString(),
            c: pageContext.c,
            sortiertnach: pageContext.sortiertnach,
        });

        void wiring.selectionEvents.navigate(
            {
                rule,
                page: {
                    ...(page.sortiertnach !== undefined ? { sortOrder: page.sortiertnach } : {}),
                    ...(page.o !== undefined ? { offset: page.o } : {}),
                    ...(page.l !== undefined ? { layout: page.l } : {}),
                    ...(page.c !== undefined ? { comparisonId: page.c } : {}),
                },
                url: pagedUrl(page, window.location.pathname, window.location.search),
            },
            'page',
        );
    }
</script>

{#if segments}
    <div class="reptile-bottom-paging__container oc-p-100 oc-mb-25">
        <ul class="reptile-bottom-paging">
            <SegmentNavButton segment={segments.segmentPreviousNavButton} {paginate} />
            <SegmentPage segment={segments.segmentFirstPage} {currentOffset} {paginate} />
            <SegmentInterval segment={segments.segmentFirstInterval} />
            <SegmentPage segment={segments.segmentBeforePreviousPage} {currentOffset} {paginate} />
            <SegmentPage segment={segments.segmentPreviousPage} {currentOffset} {paginate} />

            <SegmentPage segment={segments.segmentCurrentPage} {currentOffset} {paginate} />

            <SegmentPage segment={segments.segmentNextPage} {currentOffset} {paginate} />
            <SegmentPage segment={segments.segmentAfterNextPage} {currentOffset} {paginate} />
            <SegmentInterval segment={segments.segmentLastInterval} />
            <SegmentPage segment={segments.segmentLastPage} {currentOffset} {paginate} />
            <SegmentNavButton segment={segments.segmentNextNavButton} {paginate} />
        </ul>
    </div>
{/if}

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';
    @use '@shared/styles/colors';

    .reptile-bottom-paging__container {
        overflow: hidden;
        background: tokens.$oc-base-color-white-100;
    }

    .reptile-bottom-paging {
        float: right;
        overflow: hidden;
    }
</style>
